import BpkText, {
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import constants, { DIRECTNESS } from '../constants';
import withStrings from '../withStrings';

import type { DirectFlightLabelProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './DirectFlightLabel.module.scss';

const {
  STRINGS: { DIRECT, INDIRECT },
} = constants;

const DirectFlightLabel = ({ direct, strings }: DirectFlightLabelProps) => (
  <BpkText
    color={TEXT_COLORS.textSecondary}
    className={STYLES.DirectFlightLabel}
  >
    {direct !== DIRECTNESS.UNKNOWN &&
      strings[direct === DIRECTNESS.DIRECT ? DIRECT : INDIRECT]}
  </BpkText>
);

export default withStrings(DirectFlightLabel);
